import { createStore, applyMiddleware } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { rootReducer, rootEpic } from './root';
import { name, version } from '../../package.json';
import { fetch } from '../core/hub';

export default function configureStore(initialState = {}, { doc = null }) {
  let enhancer;

  const epicMiddleware = createEpicMiddleware({
    dependencies: { fetch: fetch({ doc }), doc },
  });
  const middlewares = [epicMiddleware];
  if (process.env.NODE_ENV === 'development') {
    middlewares.push(createLogger());

    // https://github.com/zalmoxisus/redux-devtools-extension#14-using-in-production
    const composeEnhancers = composeWithDevTools({
      // Options: https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#options
      name: `${name}@${version}`,
    });
    enhancer = composeEnhancers(applyMiddleware(...middlewares));
  } else {
    enhancer = applyMiddleware(...middlewares);
  }

  const store = createStore(rootReducer, initialState, enhancer);

  epicMiddleware.run(rootEpic);
  return store;
}
